export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    multiSelect: {
      type: Boolean,
      default: true,
    },
    callback: {
      type: Function,
      default: null,
    },
    codeEnum: {
      type: Object,
      default: () => {
        return { code: '', value: '', text: '' }
      },
    },
    codeField: {
      type: String,
      default: null,
    },
    nameField: {
      type: String,
      default: null,
    },
  },
  computed: {},
  data() {
    return {
      dialogVisible: false,
      rules: {},
      selectRows: [],
    }
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val
    },
  },
  created() {
    this.$baseEventBus.$on('ComponentReset', () => {
      this.clearSelection()
    })
  },

  methods: {
    opened() {
      this.fetchData()
      this.$emit('opened')
    },
    close() {
      this.clearSelection()
      this.queryForm = this.$options.data().queryForm
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    onSearch() {
      this.selectRows = []
      this.$refs.table?.setCurrentRow()
      this.$refs.table?.clearSelection()
      this.$refs.table?.fetchData()
    },
    fetchData() {
      this.$refs.table?.fetchData()
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    clearSelection() {
      if (this.multiSelect) {
        this.$refs.table?.clearSelection()
      } else {
        this.$refs.table?.setCurrentRow()
      }
    },
    save() {
      if (this.codeField && this.nameField) {
        this.$emit('get-selection', {
          data: this.selectRows,
          codeField: this.codeField,
          nameField: this.nameField,
        })
      } else {
        this.$emit('get-selection', this.selectRows)
      }
      if (this.$baseLodash.isFunction(this.callback)) {
        this.callback(this.selectRows)
      }
      this.close()
    },
  },
}
